import { render, staticRenderFns } from "./SuggestionModal.vue?vue&type=template&id=8fafe960&scoped=true&"
import script from "./SuggestionModal.vue?vue&type=script&lang=js&"
export * from "./SuggestionModal.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionModal.vue?vue&type=style&index=0&id=8fafe960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fafe960",
  null
  
)

export default component.exports